import { render, staticRenderFns } from "./MyAccountGeneral.vue?vue&type=template&id=ca93a89e&"
import script from "./MyAccountGeneral.vue?vue&type=script&lang=js&"
export * from "./MyAccountGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountGeneral.vue?vue&type=style&index=0&id=ca93a89e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports